<template>
  <div>
    <h1 class="font-bold break-normal text-2xl mb-1">{{ restaurant.name }}</h1>

    <p class="text-sm"><font-awesome-icon :icon="['fas', 'map-marker-alt']" class="mr-2" />{{ address }}</p>
    <p class="text-sm">
      <font-awesome-icon :icon="['far', 'clock']" class="mr-2" :class="classClock" /><span v-html="schedule"></span>
    </p>
  </div>
</template>
<script>
export default {
  props: {
    restaurant: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      classClock: '',
    };
  },
  computed: {
    address () {
      return `${this.restaurant.address}, ${this.restaurant.municipality}, ${this.restaurant.postalCode}, ${this.restaurant.province}, ${this.restaurant.country}`;
    },
    schedule () {
      let output = '';
      let horario = '';
      const showSchedule = this.restaurant.showSchedule;
      if (showSchedule.open === true) {
        horario = `${showSchedule.aux}h`;
        output = this.$t('AbiertoInfo', { horario });
      } else {
        if (showSchedule.dayAux !== '') {
          horario = `${this.$t(showSchedule.dayAux)} ${showSchedule.aux}h`;
        } else {
          horario = `${showSchedule.aux}h`;
        }
        output = this.$t('CerradoInfo', { horario });
      }

      return output;
    },
  },
};
</script>

<style></style>
